import React from "react";
import NNavbar from "../../Common/NNavbar/NNavbar";
import "../../Components/Home/Nhome.css";
import Footer from "../../Common/NFooter/Footer";

const WHY_CHOOSE = [
    {
        icon: "bi-vector-pen",
        title: "Bespoke Design",
        text: "Custom designs tailored to your space, style and entertainment needs.",
    },
    {
        icon: "bi-soundwave",
        title: "Acoustic Excellence",
        text: "Advanced acoustic treatments for immersive sound clarity.",
    },
    {
        icon: "bi-display",
        title: "Premium Technology",
        text: "We use world-class audio visual equipment for the ultimate experience.",
    },
    {
        icon: "bi-gear",
        title: "End-to-End Solutions",
        text: "From concept to completion — design, build, install and support.",
    },
    {
        icon: "bi-headset",
        title: "After Sales Support",
        text: "Reliable after-sales service and maintenance for complete peace of mind.",
    },
];

const SERVICES = [
    {
        icon: "bi-award",
        title: "Design & Consultation",
        text: "Understanding your space and crafting the perfect cinematic solution.",
        img: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?q=80&w=1200&auto=format&fit=crop",
    },
    {
        icon: "bi-soundwave",
        title: "Acoustic Treatment",
        text: "High performance acoustic solutions for perfect sound and noise control.",
        img: "../../images/projects/novo-themepark4.jpg",
    },
    {
        icon: "bi-tv",
        title: "Audio Visual Integration",
        text: "Seamless integration of premium audio, video and automation systems.",
        img: "https://images.unsplash.com/photo-1600166898405-da9535204843?q=80&w=1200&auto=format&fit=crop",
    },
    {
        icon: "bi-lightbulb",
        title: "Interiors & Lighting",
        text: "Elegant interiors and lighting to enhance your experience.",
        img: "https://images.unsplash.com/photo-1585771724684-38269d6639fd?q=80&w=1200&auto=format&fit=crop",
    },
    {
        icon: "bi-person-workspace",
        title: "Seating & Accessories",
        text: "Ergonomic, luxurious seating and accessories for maximum comfort.",
        img: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?q=80&w=1200&auto=format&fit=crop",
    },
];

const PROCESS = [
    { icon: "bi-chat-dots", title: "Consultation", text: "We understand your vision, space, requirements and budget." },
    { icon: "bi-vector-pen", title: "Design", text: "Creating customized designs and acoustic plans." },
    { icon: "bi-tools", title: "Installation", text: "Expert installation with precision and care." },
    { icon: "bi-sliders", title: "Calibration", text: "Fine-tuning audio and visuals for the perfect experience." },
    { icon: "bi-headset", title: "After Sales Support", text: "Continuous support for years of cinematic excellence." },
];

export default function NHome() {
    return (
        <div className="shc-page">
            <NNavbar />

            {/* HERO */}
            <header className="shc-hero" id="home">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="shc-hero-content">
                                <span className="shc-rule mb-3"></span>
                                <h1>
                                    Crafting
                                    <br />
                                    Cinematic Spaces.
                                    <span className="accent">Elevating Lifestyles.</span>
                                </h1>
                                <p className="lead">
                                    Luxury Home Cinema &amp; Private Theatre Solutions Tailored Just For You.
                                </p>
                                <a href="#projects" className="shc-btn shc-btn-outline-light">
                                    Explore Our Work <i className="bi bi-arrow-right ms-2"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* ABOUT */}
            <section className="shc-about" id="about">
                <div className="container">
                    <div className="row align-items-center gy-4">
                        <div className="col-lg-6">
                            <span className="shc-eyebrow">Established in 2006</span>
                            <h2>Crafting Cinematic Experiences Since 2006</h2>
                            <p>
                                Star Home Cinemas specializes in the design, supply and installation of
                                luxury home cinema and private theatre solutions. Backed by decades of
                                experience in acoustics, audio-visual integration and premium interiors,
                                we deliver bespoke cinematic spaces that combine exceptional performance
                                with timeless elegance.
                            </p>
                            <a href="#about" className="shc-btn shc-btn-outline-dark mt-2">
                                About Star Home Cinemas <i className="bi bi-arrow-right ms-2"></i>
                            </a>
                        </div>
                        <div className="col-lg-6">
                            <img
                                src="../../images/projects/project4.jpg"
                                alt="Custom home theatre with planetarium-style screen"
                                className="shc-about-img"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* WHY CHOOSE US */}
            <section className="shc-why">
                <div className="container">
                    <h2 className="shc-section-title">
                        WHY CHOOSE <span className="accent">STAR HOME CINEMAS?</span>
                    </h2>
                    <div className="shc-why-row">
                        {WHY_CHOOSE.map((item) => (
                            <div className="shc-why-item" key={item.title}>
                                <div className="shc-icon-ring">
                                    <i className={`bi ${item.icon}`}></i>
                                </div>
                                <h3>{item.title}</h3>
                                <p>{item.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* SERVICES */}
            <section className="shc-services" id="services">
                <div className="container">
                    <h2 className="shc-section-title text-dark">
                        OUR <span className="accent">SERVICES</span>
                    </h2>
                    <div className="row g-4">
                        {SERVICES.map((service) => (
                            <div className="col-12 col-sm-6 col-lg-4 col-xl" key={service.title}>
                                <div className="shc-service-card h-100">
                                    <img src={service.img} alt={service.title} className="shc-service-img" />
                                    <div className="shc-service-body">
                                        <span className="shc-service-icon">
                                            <i className={`bi ${service.icon}`}></i>
                                        </span>
                                        <h3>{service.title}</h3>
                                        <p>{service.text}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* PROCESS */}
            <section className="shc-process">
                <div className="container">
                    <h2 className="shc-section-title">
                        OUR <span className="accent">PROCESS</span>
                    </h2>
                    <div className="row shc-process-track d-flex">
                        <div className="shc-process-line d-none d-lg-block"></div>
                        {PROCESS.map((step, i) => (
                            <div className="col-12 col-sm-6 col-lg-3 shc-process-step" key={step.title}>
                                <div className="shc-process-num">{String(i + 1).padStart(2, "0")}</div>
                                <i className={`bi ${step.icon} step-icon`}></i>
                                <h3>{step.title}</h3>
                                <p>{step.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA BANNER */}
            <section className="shc-cta">
                <div className="container">
                    <div className="row g-0">
                        <div className="col-lg-6">
                            <img
                                src="../../images/projects/project19.jpg"
                                alt="Blue-lit home cinema with mountain scene on screen"
                                className="shc-cta-img"
                            />
                        </div>
                        <div className="col-lg-6 d-flex align-items-center">
                            <div className="shc-cta-content">
                                <span className="shc-eyebrow">Get Started</span>
                                <h2 className="mt-2">Ready To Build Your Dream Home Cinema?</h2>
                                <p>Let's create an immersive entertainment space you'll love for years to come.</p>
                                <a href="#contact" className="shc-btn shc-btn-solid">
                                    Get A Free Consultation <i className="bi bi-arrow-right ms-2"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}
